<script setup lang="ts">
import XShareButton from '@shared/app/components/atoms/XShareButton.vue';
import FacebookShareButton from '@shared/app/components/atoms/FacebookShareButton.vue';
import HatenaShareButton from '@shared/app/components/atoms/HatenaShareButton.vue';
import PinterestShareButton from '@shared/app/components/atoms/PinterestShareButton.vue';
import LineShareButton from '@shared/app/components/atoms/LineShareButton.vue';
</script>

<template>
  <div class="flex gap-4 flex-wrap mb-5 items-end">
    <XShareButton />
    <FacebookShareButton />
    <HatenaShareButton />
    <PinterestShareButton />
    <LineShareButton />
  </div>
</template>
